
import { useState } from 'react';

export default function ArticleSidebar() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: ''
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle form submission
    alert('Cảm ơn bạn! Chúng tôi sẽ gửi hướng dẫn chi tiết về email trong 5 phút.');
  };

  return (
    <div className="space-y-8">
      {/* Quick Contact Form */}
      <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
        <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
          <i className="ri-download-cloud-line text-orange-600"></i>
          Nhận hướng dẫn PDF chi tiết
        </h3>
        <p className="text-sm text-gray-600 mb-4">
          Tải về guide đầy đủ về thuê xe tại Mỹ với checklist và mẹo tiết kiệm
        </p>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <input
              type="text"
              placeholder="Họ và tên"
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-orange-500"
              required
            />
          </div>
          <div>
            <input
              type="email"
              placeholder="Email"
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-orange-500"
              required
            />
          </div>
          <div>
            <input
              type="tel"
              placeholder="Số điện thoại"
              value={formData.phone}
              onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-orange-500"
              required
            />
          </div>
          <button
            type="submit"
            className="w-full bg-orange-600 text-white py-2.5 px-4 rounded-lg text-sm font-semibold hover:bg-orange-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            Tải hướng dẫn miễn phí
          </button>
        </form>
      </div>

      {/* Popular Road Trip Tours */}
      <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
        <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
          <i className="ri-roadster-line text-orange-600"></i>
          Tour tự lái phổ biến
        </h3>
        
        <div className="space-y-4">
          {[
            {
              title: 'California Coast Highway',
              duration: '10 ngày',
              distance: '1,200 km',
              price: 'Từ $2,899',
              image: 'https://public.readdy.ai/ai/img_res/d823359caf02e4c897f1fa32820d2b41.jpg',
              highlights: ['Big Sur', 'San Francisco', 'Los Angeles'],
              badge: 'Bán chạy',
              badgeColor: 'bg-red-100 text-red-600'
            },
            {
              title: 'Route 66 Classic',
              duration: '14 ngày',
              distance: '3,900 km',
              price: 'Từ $3,599',
              image: 'https://readdy.ai/api/search-image?query=Historic%20Route%2066%20road%20trip%20scene%20with%20vintage%20car%20on%20classic%20American%20highway%2C%20desert%20landscape%20with%20iconic%20Route%2066%20road%20signs%2C%20nostalgic%20Americana%20atmosphere%20with%20warm%20golden%20lighting%2C%20perfect%20for%20road%20trip%20marketing&width=300&height=200&seq=route66-classic-tour&orientation=landscape',
              highlights: ['Chicago', 'Grand Canyon', 'Las Vegas'],
              badge: 'Kinh điển',
              badgeColor: 'bg-blue-100 text-blue-600'
            },
            {
              title: 'National Parks Circuit',
              duration: '12 ngày',
              distance: '2,800 km',
              price: 'Từ $3,299',
              image: 'https://readdy.ai/api/search-image?query=American%20national%20parks%20road%20trip%20with%20RV%20camping%20setup%2C%20stunning%20mountain%20and%20canyon%20landscapes%2C%20family%20enjoying%20outdoor%20adventure%2C%20beautiful%20natural%20scenery%20with%20pine%20trees%20and%20rock%20formations&width=300&height=200&seq=national-parks-tour&orientation=landscape',
              highlights: ['Yellowstone', 'Grand Teton', 'Yosemite'],
              badge: 'Thiên nhiên',
              badgeColor: 'bg-green-100 text-green-600'
            }
          ].map((tour, index) => (
            <div key={index} className="border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow cursor-pointer">
              <div className="relative mb-3">
                <img
                  src={tour.image}
                  alt={tour.title}
                  className="w-full h-32 object-cover rounded-lg"
                />
                <span className={`absolute top-2 right-2 ${tour.badgeColor} text-xs font-semibold px-2 py-1 rounded whitespace-nowrap`}>
                  {tour.badge}
                </span>
              </div>
              <h4 className="text-sm font-bold text-gray-900 mb-2">{tour.title}</h4>
              <div className="flex items-center justify-between text-xs text-gray-600 mb-2">
                <span>{tour.duration}</span>
                <span>{tour.distance}</span>
              </div>
              <div className="flex flex-wrap gap-1 mb-3">
                {tour.highlights.map((highlight, idx) => (
                  <span key={idx} className="bg-orange-50 text-orange-700 text-xs px-2 py-1 rounded">
                    {highlight}
                  </span>
                ))}
              </div>
              <div className="flex items-center justify-between">
                <span className="text-lg font-bold text-orange-600">{tour.price}</span>
                <button className="bg-orange-600 text-white px-3 py-1.5 rounded text-xs font-medium hover:bg-orange-700 transition-colors cursor-pointer whitespace-nowrap">
                  Xem chi tiết
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Car Rental Comparison */}
      <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
        <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
          <i className="ri-scales-3-line text-orange-600"></i>
          So sánh giá thuê xe
        </h3>
        
        <div className="space-y-3">
          {[
            { company: 'Enterprise', price: '$35-80', rating: 4.5, color: 'green' },
            { company: 'Hertz', price: '$40-90', rating: 4.3, color: 'yellow' },
            { company: 'Budget', price: '$25-60', rating: 4.0, color: 'blue' },
            { company: 'Avis', price: '$30-75', rating: 4.2, color: 'red' }
          ].map((company, index) => (
            <div key={index} className="flex items-center justify-between p-3 border border-gray-200 rounded-lg">
              <div className="flex items-center gap-3">
                <div className={`w-8 h-8 bg-${company.color}-100 rounded-lg flex items-center justify-center`}>
                  <i className={`ri-building-line text-${company.color}-600`}></i>
                </div>
                <div>
                  <div className="text-sm font-semibold text-gray-900">{company.company}</div>
                  <div className="flex items-center gap-1">
                    <div className="flex">
                      {Array.from({ length: 5 }, (_, i) => (
                        <i key={i} className={`ri-star-${i < Math.floor(company.rating) ? 'fill' : 'line'} text-yellow-400 text-xs`}></i>
                      ))}
                    </div>
                    <span className="text-xs text-gray-500">{company.rating}</span>
                  </div>
                </div>
              </div>
              <div className="text-right">
                <div className="text-sm font-bold text-gray-900">{company.price}</div>
                <div className="text-xs text-gray-500">mỗi ngày</div>
              </div>
            </div>
          ))}
        </div>
        
        <button className="w-full mt-4 bg-gray-100 text-gray-700 py-2 px-4 rounded-lg text-sm font-medium hover:bg-gray-200 transition-colors cursor-pointer whitespace-nowrap">
          So sánh chi tiết →
        </button>
      </div>

      {/* Expert Tips */}
      <div className="bg-gradient-to-br from-orange-500 to-red-600 rounded-xl p-6 text-white">
        <h3 className="text-lg font-bold mb-3 flex items-center gap-2">
          <i className="ri-lightbulb-line"></i>
          Mẹo từ chuyên gia
        </h3>
        <div className="space-y-3 text-sm">
          <div className="flex items-start gap-2">
            <i className="ri-check-line text-lg mt-0.5"></i>
            <span>Đặt xe Economy rồi có thể được upgrade miễn phí</span>
          </div>
          <div className="flex items-start gap-2">
            <i className="ri-check-line text-lg mt-0.5"></i>
            <span>Tham gia chương trình loyalty để nhận ưu đãi</span>
          </div>
          <div className="flex items-start gap-2">
            <i className="ri-check-line text-lg mt-0.5"></i>
            <span>Kiểm tra bảo hiểm thẻ tín dụng trước khi mua thêm</span>
          </div>
        </div>
      </div>

      {/* Related Articles */}
      <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
        <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
          <i className="ri-article-line text-orange-600"></i>
          Bài viết liên quan
        </h3>
        
        <div className="space-y-3">
          {[
            {
              title: 'Bảo hiểm du lịch Mỹ',
              readTime: '8 phút đọc',
              link: '/insurance-guide'
            },
            {
              title: 'Chi phí dự trù khi du lịch Mỹ',
              readTime: '12 phút đọc',
              link: '/budget-guide'
            },
            {
              title: 'Checklist hành lý du lịch Mỹ',
              readTime: '6 phút đọc',
              link: '/packing-guide'
            }
          ].map((article, index) => (
            <div key={index} className="flex items-center justify-between p-3 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer">
              <div>
                <div className="text-sm font-medium text-gray-900 mb-1">{article.title}</div>
                <div className="text-xs text-gray-500">{article.readTime}</div>
              </div>
              <i className="ri-arrow-right-s-line text-gray-400"></i>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
